function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 2a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-1zM7.818 5.24a.5.5 0 01.703.076l2.514 3.112a.5.5 0 01-.075.703l-.778.628a.5.5 0 01-.703-.075L6.966 6.572a.5.5 0 01.074-.703l.778-.628zM23.479 5.316a.5.5 0 01.703-.075l.778.628a.5.5 0 01.075.703L22.52 9.684a.5.5 0 01-.703.075l-.778-.628a.5.5 0 01-.074-.704l2.513-3.111z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.452 10.594a1.5 1.5 0 00-.904 0L6.501 13.45a1.075 1.075 0 00-.629.503l-3.62 4.81L5.5 19.968v5.666a1.5 1.5 0 001.048 1.43L16 30.049l9.452-2.985a1.5 1.5 0 001.048-1.43v-5.66l3.264-1.21-3.716-4.936h-.002a1.086 1.086 0 00-.547-.377l-9.047-2.857zM7.5 20.71v4.557l7.5 2.369v-6.933l-1.461 2.247L7.5 20.71zm6.854-2.681L7.045 15.72l-1.581 2.1 7.27 2.697 1.62-2.49zm4.122 4.921l6.024-2.234v4.551L17 27.636V20.68l1.476 2.27zm.805-2.431l-1.622-2.494 7.308-2.308 1.585 2.105-7.271 2.697zm2.898-6.019L16 16.451 9.82 14.5 16 12.549l6.18 1.951z",
  fill: "currentColor"
})));